import type { RouteRecordRaw } from 'vue-router';
import Permission from '@/modules/current-user/permissions/permissions';

export default [
  {
    path: 'threats',
    children: [
      {
        path: '',
        name: 'supplier-emerging-threats',
        component: () => import('./EmergingThreats.vue'),
        meta: {
          permissions: [Permission.SuppliersEmergingThreatsView],
        },
      },
      {
        path: ':id',
        name: 'supplier-emerging-threat',
        component: () => import('./EmergingThreat.vue'),
        props: true,
        meta: {
          permissions: [Permission.SuppliersEmergingThreatsView],
        },
      },
    ],
  },
] satisfies RouteRecordRaw[];
